import {SnackbarService} from "@hps/hops-react";
import {useMemo, useState} from "react";
import QrCode from "react-qr-code";

import Flex from "Components/Flex.js";
import IconButton from "Components/IconButton.js";
import Link from "Components/Link.js";
import String from "Components/String.js";
import Clipboard from "Helpers/Clipboard.js";
import LoginFormTotpInput from "Login/LoginFormTotpInput";

import FileCopyIcon from "@mui/icons-material/FileCopy";

import scss from "./TotpEnrollmentForm.module.scss";

const TotpEnrollmentForm = (
	{
		disabled,
		onChange,
		totpenroll,
		totpEnrollInputRef,
		totpr
	}
) => {

	const [manualSetupVisible, setManualSetupVisible] = useState(false);

	const otpAuthUri = useMemo(() => {
		return totpr ? `otpauth://totp/${totpr.username}?secret=${totpr.proposedSecret}&issuer=${totpr.issuer}` : null;
	}, [totpr]);


	/**
	 * Copy TOTP Proposed Secret to Clipboard
	 */
	const handleCopyProposedSecret = () => {
		Clipboard.copy(totpr?.proposedSecret);
		SnackbarService.snack("The setup code has been copied.", "success");
	};


	/**
	 * Render our QR code.
	 */
	const renderQrCode = () => {

		const dims = "12rems";
		const qrSize = (parseInt(dims) * 10);			// rem to px

		return (
			<Flex columnar={true} justifyContent="center" height={dims} width={dims}>
				{otpAuthUri && <QrCode size={qrSize} value={otpAuthUri} />}
			</Flex>
		);

	};

	return (
		<Flex>

			<Flex gap={0.5} mb={1}>
				<String
					str="Scan this QR Code with an authenticator."
					variant="body2"
				/>

				{renderQrCode()}

				<Link onClick={() => setManualSetupVisible(true)} label="Show code for manual setup" variant="body2" />

				<div className={manualSetupVisible ? scss.enrollment_manual_visible : scss.enrollment_manual_hidden}>
					<String str="If required, you can set up your authenticator manually with this code:" variant="body2" />

					<Flex
						alignItems="center"
						className={scss.enrollment_secret}
						gap={0}
						columnar={true}
						justifyContent="center">
						<String
							className={scss.enrollment_secret_text}
							str={totpr?.proposedSecret} />
						<IconButton
							icon={FileCopyIcon}
							label="Copy to Clipboard"
							onClick={handleCopyProposedSecret}
							size="small"
							title="Copy Code"
						/>
					</Flex>
				</div>
			</Flex>
			<LoginFormTotpInput
				disabled={disabled}
				inputRef={totpEnrollInputRef}
				onChange={onChange}
				name="totpenroll"
				value={totpenroll} />
		</Flex>
	);

};

export default TotpEnrollmentForm;
